import { render, staticRenderFns } from "./GeminiExchangeInput.vue?vue&type=template&id=24b2cf6a&"
import script from "./GeminiExchangeInput.vue?vue&type=script&lang=ts&"
export * from "./GeminiExchangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports